import styled from 'styled-components';
import bg from '../../assets/images/background.png'

export const Container = styled.main`
  background-image: url(${bg});
  background-size: cover;
  min-height: 100vh;
`;
